export default "__VITE_ASSET__efd0c274__"